module.exports = __webpack_public_path__ + "static/media/img_4.03f2492d.png";